import store from "@/store";
import mapHelper from "@/store/modules/common/map-helper";


export default {
    /**
     * Obtiene los headers configurados
     * @author Alejandro Trujillo Delgado
     * @returns objecto con los parametros configurados
     */
    getCoreHeaders() {
        // let refreshToken = null
        // if(store){
        //     refreshToken = store.getters[mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.getRefreshToken]
        // }
        // let headers = { 
        //     "Refreshtoken": `${refreshToken}`
        // };
        return {};
    },
    getToken(){
        let token = null
        if(store){
            token = store.getters[mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.getToken]
        }
        return "Bearer "+token
    }    
}
